import { ReactNode } from 'react';

import { Warning } from '../../Warning';

export const FormError = ({
  children,
  id,
  className,
}: {
  children: ReactNode;
  id: string;
  className?: string;
}) => {
  return (
    <Warning size="small" variant="error" className={className}>
      <Warning.Title asChild>
        <span role="alert" id={id}>
          {children}
        </span>
      </Warning.Title>
    </Warning>
  );
};
